/* HomeMedix (Oct 13, 2026): category banner pills. The selected pill (.col-hero__pill--active) is blue, but its icon is a two-tone
   SVG file (collection metafield custom.menu_image: navy #002267 + azure accent) shown as <img>, which CSS can't recolour.
   This inlines that one SVG so the CSS in sections/dynamic-col.liquid can turn only the navy parts white. Loaded by dynamic-col. */
(function () {
  if (window.__hmPillIcons) return;
  window.__hmPillIcons = true;
  var cache = {}, queued = false;
  function run() {
    queued = false;
    document.querySelectorAll('.col-hero__pill--active .col-hero__pill-icon img').forEach(function (img) {
      var u = img.getAttribute('src');
      if (!u || !/\.svg(\?|$)/i.test(u.split('&')[0])) return;
      cache[u] = cache[u] || fetch(u).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      cache[u].then(function (t) {
        var i = t.indexOf('<svg');
        if (i < 0 || !img.isConnected) return;
        var w = document.createElement('span');
        w.innerHTML = t.slice(i);
        var s = w.querySelector('svg');
        if (!s) return;
        s.setAttribute('aria-hidden', 'true');
        s.setAttribute('focusable', 'false');
        img.replaceWith(s);
      });
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }
  function boot() {
    run();
    if ('MutationObserver' in window) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
